import { loadChildRoute, saveChildRoute } from "./helper";

export default [
  {
    path: "/courses",
    beforeEnter: (to, from, next) => loadChildRoute(to, next, "/courses/0"),
  },
  {
    path: "/courses/:id",
    component: () =>
      import(/* webpackChunkName: "Courses" */ "@/views/Courses/"),

    children: [
      {
        path: "",
        name: "Course",
        beforeEnter: (to, from, next) =>
          loadChildRoute(to, next, "/courses/0/portrait"),
      },
      {
        name: "CourseContact",
        path: "contact",
        component: () =>
          import(
            /* webpackChunkName: "CourseContact" */ "@/views/Courses/Contact.vue"
          ),
        beforeEnter: (to, from, next) => saveChildRoute(to, next),
        props: true,
      },
      {
        name: "CourseList",
        path: "list",
        component: () =>
          import(
            /* webpackChunkName: "CourseList" */ "@/views/Courses/List.vue"
          ),
        beforeEnter: (to, from, next) => saveChildRoute(to, next),
        props: true,
      },
      {
        name: "CourseLog",
        path: "log",
        component: () =>
          import(
            /* webpackChunkName: "CourseList" */ "@/views/Courses/ChangeLog.vue"
          ),
        beforeEnter: (to, from, next) => saveChildRoute(to, next),
        props: true,
      },
      {
        name: "CoursePortrait",
        path: "portrait",
        component: () =>
          import(
            /* webpackChunkName: "CoursePortrait" */ "@/views/Courses/Portrait.vue"
          ),
        beforeEnter: (to, from, next) => saveChildRoute(to, next),
        props: true,
      },
      {
        name: "CourseReport",
        path: "report",
        component: () =>
          import(
            /* webpackChunkName: "CourseReport" */ "@/views/Courses/Report.vue"
          ),
        beforeEnter: (to, from, next) => saveChildRoute(to, next),
        props: true,
      },
    ],
    props: true,
  },
];
